import WidgetSideBar from './component'

export default WidgetSideBar
